import type { Environment } from './environment';

export class SystemService {
  // eslint-disable-next-line no-useless-constructor
  constructor(private environment: Environment) {}

  get Debug(): boolean {
    return this.environment.Debug || this.environment.Development;
  }

  get Verbose(): boolean {
    return this.environment.Verbose;
  }

  get Region(): string {
    return this.environment.Region;
  }

  redirectTo(url: string): void {
    console.log('Begin Redirect To', url);
    if (this.environment.NoRedirect) {
      return;
    }
    window.location.href = url;
  }

  reportError(...err: any[]): void {
    if (this.Debug) {
      console.error(...err);
    }
  }

  reportVerboseError(...err: any[]): void {
    if (this.Verbose) {
      console.error(...err);
    }
  }
}
